import { BoxProps, Typography } from '@mui/material'
import { ButtonEx, FlexCol, FlexRow, MessageDialog } from '@xylabs/sdk-react'
import { useState } from 'react'

import InventorySelectDialog from './InventorySelectDialog'
import Item from './Item'
import ItemSlot from './ItemSlot'
import ItemSlotType from './ItemSlotType'
import ItemViewer from './ItemViewer'

type HintBehavior = 'always' | 'hover' | 'none'

interface Props extends BoxProps {
  hint?: HintBehavior
  itemSlot: ItemSlot
  onItemSlotChange?: (slot?: ItemSlot) => void
}

const ItemSlotViewer: React.FC<Props> = (props) => {
  const { itemSlot, onItemSlotChange, hint = 'hover' } = props
  const [showHint, setShowHint] = useState(hint === 'always' ? itemSlot.item?.name ?? '' : undefined)
  const [showSlotLockedMessage, setShowSlotLockedMessage] = useState(false)
  const [showInventorySelectDialog, setShowInventorySelectDialog] = useState(false)

  const onButtonClick = () => {
    if (itemSlot.type === ItemSlotType.Disabled) {
      setShowSlotLockedMessage(true)
    } else if (itemSlot.type === ItemSlotType.Equippable) {
      setShowInventorySelectDialog(true)
    }
  }

  const onMouseEnter = () => {
    if (hint === 'always' || hint === 'hover') {
      setShowHint(itemSlot.item?.name)
    }
  }

  const onMouseLeave = () => {
    if (hint === 'hover') {
      setShowHint('')
    }
  }

  const disabled = itemSlot.type === ItemSlotType.Disabled

  const onSelectClose = (selected?: Item) => {
    setShowInventorySelectDialog(false)
    itemSlot.item = selected
    if (hint === 'always') {
      setShowHint(itemSlot.item?.name)
    }
    onItemSlotChange?.(itemSlot)
  }

  return (
    <FlexCol>
      <ButtonEx disabled={disabled} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <ItemViewer item={itemSlot.item} onClick={onButtonClick} disabled={disabled} />
      </ButtonEx>
      {hint !== 'none' ? (
        <FlexRow style={{ opacity: showHint ? 1 : 0 }} width={64}>
          <Typography noWrap={true} variant="body2" style={{ zoom: 0.7 }}>
            {itemSlot.item?.name ?? 'Empty'}
          </Typography>
        </FlexRow>
      ) : null}
      <InventorySelectDialog
        title="Equip Item"
        onSelect={onSelectClose}
        onCancel={() => setShowInventorySelectDialog(false)}
        open={showInventorySelectDialog}
      />
      <MessageDialog onClose={() => setShowSlotLockedMessage(false)} open={showSlotLockedMessage} title={'Slot Locked'}>
        <Typography variant="body1">This slot is has not yet been unlocked.</Typography>
      </MessageDialog>
    </FlexCol>
  )
}

export default ItemSlotViewer
